import {
  collection,
  deleteDoc,
  doc,
  getDocs,
  orderBy,
  query,
  serverTimestamp,
  setDoc
} from "firebase/firestore";
import { db } from "../firebase/config";

// Saved signers live under /users/{uid}/contacts keyed by email so an upsert
// on the same address updates the existing record instead of duplicating.
const safeKey = (email) => email.trim().toLowerCase().replace(/[^a-z0-9]+/g, "_");

export async function listContacts(uid) {
  const q = query(
    collection(db, "users", uid, "contacts"),
    orderBy("name")
  );
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}

export async function upsertContact(uid, contact) {
  const id = safeKey(contact.email);
  await setDoc(
    doc(db, "users", uid, "contacts", id),
    {
      name: contact.name.trim(),
      email: contact.email.trim().toLowerCase(),
      phoneE164: contact.phoneE164,
      updatedAt: serverTimestamp(),
      lastUsedAt: serverTimestamp()
    },
    { merge: true }
  );
}

export async function removeContact(uid, contactId) {
  await deleteDoc(doc(db, "users", uid, "contacts", contactId));
}
